import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import { environment } from "../environments/environment";
import { ISubProduct } from "../models/subProduct.model";

@Injectable({
  providedIn: "root"
})

export class VariantService{

  constructor(private http: HttpClient) {
  }

  allSubProductsOfUser(idProduct: number, page: number, size: number): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/subProduct/product/${idProduct}${size ? '?page=' + page + '&size=' + size : ''}`, {headers: headers});
  }

  subProductById(id?: number): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/subProduct/${id}`, {headers: headers});
  }

  deleteSubProduct(subProduct:ISubProduct){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.delete(`${environment.url}/subProduct/`+subProduct.id,{'headers': headers});
  }

  // getKahpooShopsSubProductByDate(prod_id: number, startDate: any, endDate: any): Observable<any> {
  //   let headers = new HttpHeaders();
  //   headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
  //   return this.http.get(`${environment.url}/subProduct/product/beetwentwodates/${prod_id}&startDate=${startDate}&endDate=${endDate}`);
  // }

  getKahpooShopsSubProductByDate(prod_id: number, startDate: string, endDate: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/subProduct/product/beetwentwodates/${prod_id}?startDate=${startDate}&endDate=${endDate}`, { headers: headers });
}



}
